module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg34.ddc1d494.jpg";